import Vue from "@/libraries/vue";
const shareStore = new Vue({
    name: "ShareStore",
    data: {
        socialDialog: {
            model: false,
            data: {}
        },
        shareText: "",
        shareUrl: "",
        fullSrc: "",
    },
    methods: {
        async share(msg, subject, image, url) {
            console.log("shareStore share");
            msg = msg || "";
            subject = subject || "";
            image = image || "";
            url = url || location.href.split("//")[1];
            let title = document.querySelector("title");
            let message = title ? title.innerText : "";
            console.log("navigator.share", navigator && navigator.share);
            if (navigator && navigator.share) {
                const data = {
                    title: subject,
                    text: message,
                    url
                };
                navigator.share(data);
                return;
            }
            this.socialDialog = {
                model: true,
                data: {
                    message,
                    image,
                    url
                }
            };
        },
    }
});
export default shareStore;
